import { Box } from "@mui/material";
import React, { useState, useEffect } from "react";
import EditableTable from "components/Table/EditableTable";
import formService from "services/feedback-service";
import ConfirmationModal from "modals/miscellaneous/ConfirmationModal";

export default function OfficesTable({
  data,
  setSelectedData,
  loadingState,
  updateTableFunction,
}) {
  const [selectedOffice, setSelectedOffice] = useState();
  const [rowToDelete, setRowToDelete] = useState();

  const [open, setOpen] = useState(false);
  const [promptResponse, setPromptResponse] = useState(null);
  const [submit, setSubmit] = useState(false);
  const [submitKind, setSubmitKind] = useState("");
  const [promptDesc, setPromptDesc] = useState("");

  const [loading, setLoading] = useState(false);
  // const [error, setError] = useState("");

  setSelectedData(selectedOffice);

  useEffect(() => {
    if (rowToDelete) {
      setPromptDesc("Are you sure you want to delete this data?");
      setSubmitKind("delete");
      setOpen(true);
    }
  }, [rowToDelete]);

  useEffect(() => {
    if (!open && submit && promptResponse) {
      // setLoading(true);

      formService
        .deleteOffice(rowToDelete ? rowToDelete[0]?.id : "")
        .then(() => {
          alert("Office deleted successfully");
          setRowToDelete(null);
          setSubmit(false);
          updateTableFunction();
        })
        .catch((err) => {
          alert(err?.message);
          setRowToDelete(null);
          setSubmit(false);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [submit, promptResponse]);

  const columns = [
    { field: "id", headerName: "ID", width: 70 },
    {
      field: "title",
      headerName: "Offices",
      width: 500,
    },
    {
      field: "location",
      headerName: "Designation",
      width: 500,
    },
  ];

  return (
    <Box sx={{ width: "100%" }}>
      <ConfirmationModal
        open={open}
        handleClose={() => setOpen(false)}
        setPromptResponse={setPromptResponse}
        setSubmit={setSubmit}
        submitKind={submitKind}
        promptDesc={promptDesc}
      />
      <EditableTable
        data={data}
        columns={columns}
        checkbox
        loading={loadingState || loading}
        singleSelect
        selectedData={setSelectedOffice}
        rowToDelete={setRowToDelete}
        height="60vh"
        remove
      />
    </Box>
  );
}
